import { render, staticRenderFns } from "./CalificacionEditar.vue?vue&type=template&id=8bd59046"
import script from "./CalificacionEditar.vue?vue&type=script&lang=js"
export * from "./CalificacionEditar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports